import { ButtonContent } from "../../global/boton/ButtonContent";

function HeroSection({ bgImg, bgImg1, bgImg2, bgImg3, title, texts }) {

  const BgImages = [
    bgImg,
    bgImg1,
    bgImg2,
    bgImg3,
  ]

  return (
    <section className={'svgBoxRectanguloBottonRigth'}>

      <div className="pic-wrapper svgHerosection2  w-full md:h-[140vh]" >
        {
          BgImages.map((item, index) => {
            return (
              <figure
                key={index}
                className={`pic-${index + 1}`}
                style={{ background: `url("${item}")` }}
              ></figure>
            )
          })
        }
        <div className="z-10 relative w-4/5 mx-auto md:h-[140vh] flex flex-col justify-start mt-8 items-center pt-60">
          <div className="w-full flex flex-col justify-center items-center">
            <h1 className="text-white text-center text-[35px] md:text-[60px]">
              {title}
            </h1>
            <p className="text-white text-center">
              {texts}
            </p>
          </div>
          {/* <div className="hidden md:flex md:flex-row">
            <img src="https://firebasestorage.googleapis.com/v0/b/resource-36ef7.appspot.com/o/resource%2F6%20years.png?alt=media&token=afa7d7a4-f6c2-4757-8677-634227b509d9" alt="years of experience" className="w-[350px] h-[360px] object-cover md:mb-20 mx-auto" />
             <img src="https://firebasestorage.googleapis.com/v0/b/resource-36ef7.appspot.com/o/resource%2FInsignia%20de%20Google.png?alt=media&token=465c161a-3b84-4d47-ac48-ab9f218d7cbe" alt="years of experience" className="w-[280px] h-[340px] object-cover md:mb-20 mx-auto mt-5" />
          </div> */}
          <div className="w-full flex justify-center">
            <ButtonContent btnStyle={'three'} />
          </div>

        </div>
      </div>


    </section>

  )
}

export default HeroSection;
